import React from "react";
import "../style/FilterBar.css";

const FilterBar = ({ filters, setFilters }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const clearFilters = () => {
    setFilters({
      startDate: "",
      endDate: "",
      category: "",
    });
  };

  return (
    <div className="filter-bar" style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap", marginBottom: "10px" }}>
      <div>
        <label htmlFor="startDate">Start Date:</label>
        <input
          id="startDate"
          name="startDate"
          type="date"
          value={filters.startDate}
          onChange={handleChange}
        />
      </div>

      <div>
        <label htmlFor="endDate">End Date:</label>
        <input
          id="endDate"
          name="endDate"
          type="date"
          value={filters.endDate}
          onChange={handleChange}
        />
      </div>

      <div>
        <label htmlFor="category">Category:</label>
        <input
          id="category"
          name="category"
          type="text"
          placeholder="Category"
          value={filters.category}
          onChange={handleChange}
        />
      </div>

      <button onClick={clearFilters} style={{ padding: "6px 12px", background: "#eee", border: "1px solid #ccc", borderRadius: "4px" }}>
        Clear Filters
      </button>
    </div>
  );
};

export default FilterBar;
